import React, { useEffect, useState } from 'react';
import { selectedDepartmentAtom } from '../shared/selected.department';
import { useAtom } from 'jotai';
import { fetchService } from '../adapaters/fetchService';
import { fetchSpeciality } from '../adapaters/fetchSpeciality';

const useFetchServiceOrSpeciality = () => {
  const [data, setData] = useState(null);

  const [selectedDepartment] = useAtom(
    selectedDepartmentAtom
  );

  useEffect(() => {
    if (selectedDepartment) {
      fetchService((val) => {
        setData((prev) => ({
          ...prev,
          serviceBased: val,
        }));
      }, selectedDepartment);

      fetchSpeciality((val) => {
        setData((prev) => ({
          ...prev,
          specialityBased: val,
        }));
      }, selectedDepartment);
    }
  }, [selectedDepartment]);

  return data;
};

export default useFetchServiceOrSpeciality;
